import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getStoredUser } from '../../helpers/user-storage.util';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'opt-in-dialog',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, ReactiveFormsModule],
  templateUrl: './opt-in-dialog.component.html',
  styleUrl: './opt-in-dialog.component.scss',
})
export class OptInDialogComponent {
  _active: boolean = false;
  @Input() set active(value: boolean) {
    this._active = value;
    if (value) this.isSubmitting = false;
  }
  get active() { return this._active; }

  @Output() handleOptIn = new EventEmitter<any>();
  @Output() modalClosed = new EventEmitter<boolean>();

  user = getStoredUser();
  isSubmitting = false;
  phoneFormGroup: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.phoneFormGroup = this.formBuilder.group({
      selectedPhone: this.user.phone,
    });
  }

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }

  submit() {
    this.isSubmitting = true;
    if (this.user.phone && this.user.phone2) {
      if (this.phoneFormGroup.value.selectedPhone === this.user.phone) {
        this.user = {
          ...this.user,
          usePhoneForSms: true,
          usePhone2ForSms: false, // will reset if previous error
        };
      } else if (this.phoneFormGroup.value.selectedPhone === this.user.phone2) {
        this.user = {
          ...this.user,
          usePhoneForSms: false,
          usePhone2ForSms: true,
        };
      }
    } else if (this.user.phone) {
      this.user = {
        ...this.user,
        usePhoneForSms: true,
        usePhone2ForSms: false,
      };
    } else if (this.user.phone2) {
      this.user = {
        ...this.user,
        usePhoneForSms: false,
        usePhone2ForSms: true,
      };
    }
    this.handleOptIn.emit(this.user);
  }
}
